'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'

export const FullPageModalFooter = ({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={cn('mt-6 flex flex-col items-center gap-6', className)}>
      {children}
    </div>
  )
}
